// Copyright (c) 2016 Deere & Company

import SearchResults, {getDefaultState} from '../state/search-results';
import actions from '../../actions-list';

const updateSearchResults = (state, action) =>
    SearchResults.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_PIP_SEARCH_RESULTS_SUCCESS]: updateSearchResults
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/pip/pip-search/reducers/search-results.js